/**
 * Structured clone that falls back to a JSON.parse/stringify if the value is not cloneable
 *
 * If it can't be stringified, returns an object with a message about why
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();export function safeStructuredClone<T>(value: T) {
  try {
    return structuredClone(value)
  } catch {
    try {
      // oxlint-disable-next-line unicorn/prefer-structured-clone, typescript/consistent-type-assertions -- fallback clone path; grandfathered: json-parse
      return JSON.parse(JSON.stringify(value)) as Record<string, unknown>
    } catch (error: unknown) {
      // Just in case JSON.stringify or parse fails, we'll return a plain object with the error message
      // So we don't crash the app with a logger error
      const errorMessage =
        error instanceof Error ? error.message : 'Unknown error'
      return {
        message: `Cannot clone value: ${errorMessage}`,
      }
    }
  }
}
